export interface MyIpListReturnState {
  kind: 'list';
  page: number;
  scrollTop: number;
}

export type MyIpAssetReturnHost = 'teamFlowSidebar' | 'teamFlowNodePanel' | 'assetsPage';

/** 只保存右栏页签和图片索引，具体媒体仍须返回后重新鉴权读取。 */
export interface MyIpAssetDetailViewState {
  tab: 'settings' | 'materials';
  mode: 'main' | 'threeViews';
  imageIndex: number;
}

export interface MyIpAssetReturnState {
  kind: 'asset';
  host: MyIpAssetReturnHost;
  assetType: 'personal' | 'official';
  /** 候选来源可与宿主页签不同；官方兜底返回时仍回个人资产页签。 */
  listAssetType?: 'personal' | 'official';
  input: string;
  keyword: string;
  selectedId: string;
  page: number;
  scrollTop: number;
  panelScrollTop: number;
  detailScrollTop: number;
  detailView?: MyIpAssetDetailViewState;
}

export type MyIpReturnState = MyIpListReturnState | MyIpAssetReturnState;
export interface MyIpAssetReturnRequest { scopeKey: string; state: MyIpAssetReturnState; }

let pending: MyIpAssetReturnRequest | undefined;
type MyIpAssetReturnReceiver = (request: MyIpAssetReturnRequest) => void;
const receivers = new Map<MyIpAssetReturnHost, MyIpAssetReturnReceiver>();
const delivered = new WeakSet<MyIpAssetReturnRequest>();

/** 宿主与应用初始化不保证顺序；只向匹配的真实入口交付一次，避免侧栏抢走加号弹窗状态。 */
function deliver(): void {
  if (!pending) return;
  const receiver = receivers.get(pending.state.host);
  if (!receiver) return;
  const request = pending;
  pending = undefined;
  delivered.add(request);
  receiver(request);
}

/** 合法导航记录由应用鉴权后发布；离开路由或切换身份时撤回尚未交付的请求。 */
export function requestMyIpAssetReturn(request: MyIpAssetReturnRequest): () => void {
  if (!delivered.has(request)) pending = request;
  deliver();
  return () => { if (pending === request) pending = undefined; };
}

/** 每种真实入口独立注册；加号入口由常驻侧栏唤起原 NodePanel，不创建替代弹窗。 */
export function subscribeMyIpAssetReturn(handler: (request: MyIpAssetReturnRequest) => void, host: MyIpAssetReturnHost = 'teamFlowSidebar'): () => void {
  receivers.set(host, handler);
  deliver();
  return () => { if (receivers.get(host) === handler) receivers.delete(host); };
}
